import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Safety net: an unhandled rejection (e.g. a cancelled request during a cold
// start) must never surface as an opaque runtime error. Logged without payloads.
window.addEventListener("unhandledrejection", (event) => {
  const status = event.reason?.response?.status ?? event.reason?.code ?? "unknown";
  // eslint-disable-next-line no-console
  console.warn(`[ArtPart] Unhandled request rejection (${status})`);
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
